import React, { Component } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import "./kycDocument.css";

class kycDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "",
      chargesEnabled: false,
      payoutsEnabled: false,
      loading: false,
    };
  }

  // Redirige vers l'onboarding / le tableau de bord Stripe Connect.
  // Stripe collecte l'identité (KYC) et le compte bancaire de façon sécurisée.
  configurerPaiements = () => {
    this.setState({ loading: true });
    const headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    });

    fetch(process.env.REACT_APP_BACKEND_URL + "/serveur/account", {
      method: "POST",
      headers: headers,
    })
      .then((response) => response.json())
      .then((url) => {
        if (typeof url === "string" && url.startsWith("http")) {
          window.location.href = url;
        } else {
          window.alert(
            (url && url.message) ||
              "Une erreur s'est produite, veuillez réessayer."
          );
          this.setState({ loading: false });
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  checkKyc = () => {
    const headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "bearer " + localStorage.getItem("token"),
    });

    fetch(process.env.REACT_APP_BACKEND_URL + "/serveur/kyc-statut", {
      method: "get",
      headers: headers,
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          status: data.status,
          chargesEnabled: data.chargesEnabled,
          payoutsEnabled: data.payoutsEnabled,
        });
      });
  };

  componentDidMount() {
    this.checkKyc();
  }

  render() {
    const { status, loading } = this.state;
    return (
      <Container className="cagnotteCont">
        <Row className="rowId">
          <Col>
            <div className="kyc">
              <p className="titleKyc">Configuration de vos paiements</p>
              <p>
                Vos informations d'identité et votre compte bancaire sont gérés
                de façon sécurisée par Stripe, notre prestataire de paiement.
              </p>

              <div className="kycStatut">
                <p className="kycTitleStatut">Statut :</p>
                <p className="statutValid">
                  {status === "VALIDATED"
                    ? "Compte validé — vous pouvez recevoir et retirer vos pourboires."
                    : ""}
                </p>
                <p className="statutIn">
                  {status === "EN COURS"
                    ? "Vos informations sont en cours de vérification par Stripe."
                    : ""}
                </p>
                <p className="statutIn">
                  {!status || status === "NONE"
                    ? "Vous n'avez pas encore configuré votre compte de paiement."
                    : ""}
                </p>
              </div>

              <Button onClick={this.configurerPaiements} disabled={loading}>
                {status === "VALIDATED"
                  ? "Gérer mes informations de paiement"
                  : "Configurer mes paiements"}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default kycDocument;
